import { InputAdornment, ListSubheader, TextField, Tooltip, Typography } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import OutlinedInput from '@mui/material/OutlinedInput';
import React, { FC } from 'react';

import {
  DealerSelectApplyButton,
  DealerSelectCheckbox,
  DealerSelectClockIcon,
  DealerSelectFormControl,
  DealerSelectListSubheader,
  DealerSelectOnlyButton,
  DealerSelectResetButton,
  DealerSelectSelect,
} from './DealerSelect.styled';
import useDealerSelect from './hooks/useDealerSelect';
import { useTickets } from 'contexts/TicketsContext';
import { TicketsRefinementKeysE } from 'declarations/enums/tickets';
import { CloseIcon, SearchIcon } from 'icons';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => event.stopPropagation(),
    style: {
      maxHeight: ITEM_HEIGHT * 10 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
  autoFocus: false,
};

const DealerSelect: FC = () => {
  const { getSearchParam, dealerSelectedRoofTopCount } = useTickets();

  const {
    roofTops,
    searchText,
    allChecked,
    isOpen,
    displayedRoofTops,
    tempSelectedRooftopIds,
    setIsOpen,
    setSearchText,
    handleAllClick,
    handleCheckboxClick,
    handleOnlyClick,
    handleResetClick,
    handleApplyClick,
    clearSearchText,
  } = useDealerSelect();

  const isRoofTopIdFilterCleared = !getSearchParam(TicketsRefinementKeysE.RoofTopId);

  return (
    <div>
      <DealerSelectFormControl>
        <InputLabel id="multiple-checkbox-label"></InputLabel>
        <DealerSelectSelect
          labelId="multiple-checkbox-label"
          id="multiple-checkbox"
          multiple
          onClick={() => setIsOpen(!isOpen)}
          open={isOpen}
          value={[`Dealerships ${dealerSelectedRoofTopCount}`]}
          onChange={() => {}}
          input={<OutlinedInput label="" />}
          renderValue={() =>
            isRoofTopIdFilterCleared && dealerSelectedRoofTopCount === roofTops.length
              ? `Dealerships All`
              : `Dealerships ${dealerSelectedRoofTopCount}`
          }
          MenuProps={MenuProps}
          onClose={clearSearchText}
        >
          <ListSubheader>
            <TextField
              size="small"
              autoFocus
              placeholder="Type to search..."
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                endAdornment: searchText && (
                  <InputAdornment position="end">
                    <CloseIcon onClick={clearSearchText} style={{ cursor: 'pointer' }} />
                  </InputAdornment>
                ),
              }}
              value={searchText}
              onChange={e => setSearchText(e.target.value)}
              onKeyDown={e => {
                if (e.key !== 'Escape') {
                  e.stopPropagation();
                }
              }}
              style={{ position: 'relative', zIndex: 1 }}
            />
          </ListSubheader>
          <MenuItem key={'All'} value={'All'}>
            <DealerSelectCheckbox checked={allChecked} onClick={() => handleAllClick()} />
            <ListItemText primary={'All'} />
          </MenuItem>
          {displayedRoofTops?.map(roofTop => (
            <MenuItem key={roofTop.name} value={roofTop.name}>
              <DealerSelectCheckbox
                checked={tempSelectedRooftopIds.includes(roofTop.id)}
                onClick={() => handleCheckboxClick(roofTop)}
                style={{ position: 'relative', zIndex: 0 }}
              />
              <Tooltip title={roofTop.name} key={roofTop.name}>
                <ListItemText primary={<Typography noWrap>{roofTop.name}</Typography>} />
              </Tooltip>
              <DealerSelectOnlyButton onClick={() => handleOnlyClick(roofTop.id)}>
                Only
              </DealerSelectOnlyButton>
            </MenuItem>
          ))}
          <DealerSelectListSubheader>
            <DealerSelectResetButton onClick={() => handleResetClick()}>
              <DealerSelectClockIcon />
              Reset
            </DealerSelectResetButton>
            <DealerSelectApplyButton onClick={() => handleApplyClick()}>
              Apply & Save
            </DealerSelectApplyButton>
          </DealerSelectListSubheader>
        </DealerSelectSelect>
      </DealerSelectFormControl>
    </div>
  );
};

export default DealerSelect;
